import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store/index'


import SignUp from '@/pages/auth/UserSignUp';
import Login from '@/pages/auth/UserLogin';
import Logout from '@/pages/auth/UserLogout';
import PageHome from '@/pages/PageHome';
import Upload from '@/pages/PageImageUpload';

import ImagesListPending from '@/pages/lists/ImagesListPending';
import ImagesListSelected from '@/pages/lists/ImagesListSelected';
import ImagesListPublished from '@/pages/lists/ImagesListPublished';
import ImagesListUnusable from '@/pages/lists/ImagesListUnusable';

// not used??
import ActionAlert from '@/components/dashboard/ActionAlert';



import PageSandbox from '@/pages/PageSandbox';


Vue.use(VueRouter)

const routes = [

  // {
  //   path: '/upload-result',
  //   name: 'UploadResult',
  //   component: UploadResult,
  //   meta: {
  //     requiresAuth: true,
  //     title: 'Upload Image Result'
  //   },
  //   beforeEnter: (to, from, next) => {
  //     if (from.name !== 'Upload') {
  //       console.log('from.name', from.name)
  //       return next('/')
  //     }
  //     next();
  //   }
  // },

  {
    path: '/edit-image-text/:id',
    name: 'EditImageText',
    meta: {
      requiresAuth: true,
      title: 'Edit Image Text'
    },
    component: () => import(/* webpackChunkName: "editimagetext" */ '@/pages/PageImageTextEdit')
  },
  {
    path: '/replace-image/:id',
    name: 'ReplaceImage',
    meta: {
      requiresAuth: true,
      title: 'Edit Image Text'
    },
    component: () => import(/* webpackChunkName: "replaceimage" */ '@/pages/PageImageReplace')
  },

  {
    path: '/upload-image',
    name: 'Upload',
    component: Upload,
    meta: {
      requiresAuth: true,
      title: 'Upload Image'
    },
  },

  {
    path: '/images-list-pending',
    name: 'ImagesListPending',
    component: ImagesListPending,
    meta: {
      requiresAuth: true,
      title: 'My Uploaded Images'
    },
  },

  {
    path: '/images-list-selected',
    name: 'ImagesListSelected',
    component: ImagesListSelected,
    meta: {
      requiresAuth: true,
      title: 'My Selected Images'
    },
  },
  {
    path: '/images-list-published',
    name: 'ImagesListPublished',
    component: ImagesListPublished,
    meta: {
      requiresAuth: true,
      title: 'My Published Images'
    },
  },
  {
    path: '/images-list-unusable',
    name: 'ImagesListUnusable',
    component: ImagesListUnusable,
    meta: {
      requiresAuth: true,
      title: 'My Unusable Images'
    },
  },


  // {
  //   path: '/rogue-upload',
  //   name: 'RogueUpload',
  //   meta: {
  //     // requiresAuth: true,
  //     title: 'Rogue Upload'
  //   },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "rogueupload" */ '@/pages/PageRogueUpload')
  // },

  {
    path: '/contact',
    name: 'Contact',
    meta: {
      requiresAuth: true,
      title: 'Contact Us'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "contact" */ '@/pages/PageContact')
  },

  {
    path: '/refer',
    name: 'Refer',
    meta: {
      requiresAuth: true,
      title: 'Tell Others'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "refer" */ '@/pages/PageRefer')
  },

  {
    path: '/faq',
    name: 'FAQ',
    meta: {
      requiresAuth: true,
      title: 'FAQs'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "faq" */ '@/pages/PageFaq')
  },

  {
    path: '/image-guidelines',
    name: 'ImageGuidelines',
    meta: {
      requiresAuth: true,
      title: 'Image Guidelines'
    },
    component: () => import(/* webpackChunkName: "imgguide" */ '@/pages/PageImageGuidelines')
  },

  {
    path: '/app-overview',
    name: 'AppOverview',
    meta: {
      requiresAuth: true,
      title: 'App Overview'
    },
    component: () => import(/* webpackChunkName: "appoview" */ '@/pages/PageAppOverview')
  },


  {
    path: '/alert',
    name: 'Alert',
    component: ActionAlert,
    meta: {
      title: 'Alert'
    }
  },


  // Match signup url containing an ending referral code segment. 
  // Load the page if correct format for a ref code is detected (otherwise will 404 redirect).
  // NOTE: If segment str matches, NOT implying it's an actual ref code, just that it's the proper format.
  {
    path: '/signup/par([2-9])-([a-z2-9]{5})',
    name: 'SignUp Referral',
    component: SignUp,
    meta: {
      onlyLoggedOut: true,
      title: 'SignUp'
    },
  },

  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    meta: {
      onlyLoggedOut: true,
      title: 'Sign Up'
    }
  },

  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      onlyLoggedOut: true,
      title: 'Login'
    },
    beforeEnter: (to, from, next) => {
      // console.log('BEFORE LOGIN PAGE to and from:', to.path, from.path)
      store.dispatch('setLoginRdq', to.query.redirect);
      next();
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
      requiresAuth: true,
      title: 'Logout'
    }
  },

  {
    path: '/profile',
    name: 'User Profile',
    meta: {
      requiresAuth: true,
      title: 'User Profile'
    },
    component: () => import(/* webpackChunkName: "userProfile" */ '@/pages/PageUserProfile')
  },


  {
    path: '/change-email',
    name: 'ChangeEmail',
    meta: {
      requiresAuth: true,
      title: 'Change Email'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "changeEmail" */ '@/pages/auth/UserChangeEmail')
  },

  {
    path: '/change-password',
    name: 'ChangePassword',
    meta: {
      requiresAuth: true,
      title: 'Change Password'
    },
    component: () => import(/* webpackChunkName: "changePassword" */ '@/pages/auth/UserChangePassword')
  },

  {
    path: '/delete-account',
    name: 'Delete Account',
    meta: {
      requiresAuth: true,
      title: 'Delete Account'
    },
    component: () => import(/* webpackChunkName: "delAcct" */ '@/pages/PageDeleteAccount')
  },





  {
    path: '/reset-password',
    name: 'ResetPassword',
    meta: {
      onlyLoggedOut: true,
      title: 'Reset Password'
    },
    component: () => import(/* webpackChunkName: "resetPassword" */ '@/pages/auth/UserResetPassword')
  },


  // {
  //   path: '/sandbox/:referralCode',
  //   name: 'PageSandboxR',
  //   component: PageSandbox,
  //   meta: {
  //     requiresAuth: true,
  //     title: 'Sandbox Ref'
  //   },
  // },

  {
    path: '/sandbox',
    name: 'PageSandbox',
    component: PageSandbox,
    meta: {
      title: 'Sandbox'
    }
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }

  {
    path: '/404',
    name: 'PageNotFound',
    component: () => import('@/pages/Page404NotFound'),
    meta: {
      title: '404 Page Not Found',
    }
  },


  {
    path: '/',
    name: 'PageHome',
    component: PageHome,
    meta: {
      // requiresAuth: true,
      title: 'Home'
    },
    beforeEnter: (to, from, next) => {
      var justLoggedIn = from.name === 'Login' || from.name === 'SignUp' ? true : false;
      store.dispatch('setJustLoggedIn', justLoggedIn)
      store.dispatch('setLoginRdq', to.query.redirect);
      next();
    }
  },

  {
    path: '/*',
    name: '404',
    component: () => import('@/pages/Page404NotFound'),
    meta: {
      title: '404 Page Not Found',
      pageNotFound: true
    }
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



router.beforeEach((to, from, next) => {
  // console.log('BEFORE PAGE: path from:', from.fullPath, '   --- path to:', to.fullPath);
  // console.log('to object', to);

  document.title = 'Pixapup ' + to.meta.title || 'Pixapup App';

  // Part of the 'page-overlay-showing' style is to remove scroll bars, i.e. during image upload, when overlay is showing. 
  // If user hits back button during upload, that page's js won't complete to where this style class is removed... so, could have 
  // condition where NO page they click to will have scroll bars. So, before entering each route, remove this class.
  document.body.classList.remove('page-overlay-showing');

  var authUser = store.getters['auth/isAuthenticated']; //store.state.auth.user;
  var onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut);
  var protectedRoute = to.matched.some(record => record.meta.requiresAuth);
  var pageNotFound = to.matched.some(record => record.meta.pageNotFound);
  if (!authUser && protectedRoute) {
    // console.log('router.app', router.app)
    store.dispatch('setPageAccess', 'protected'); // Gets reset to '' in login page component 
    return next({
      path: '/login',
      query: {
        redirect: 'reqauth' //to.name.toLowerCase()
      }
    })
  }
  if (authUser && onlyLoggedOut) {
    store.dispatch('setPageAccess', 'onlyLoggedOut'); // Gets reset to '' in home page component 

    return next({
      path: '/',
      query: {
        redirect: 'reqlogout' //to.name.toLowerCase()
      }
    })
  }
  if (authUser && pageNotFound) {
    // stateUtil.initState(store, router.app.$fapi);
    // hmmm... nuthin ...
  }
  next();
})



export default router